<template>
  <div
    :class="[
      $style.wrapper,
      isMyPosition && $style.isMyPosition
    ]"
    class="p-2"
  >
    <div class="d-flex w-100">
      <div class="d-flex flex-fill align-items-center">
        <div :class="$style.rankText">
          {{ rank }}
        </div>
        <template v-if="isUsersLoading">
          <BaseLoading :min-height="20" />
        </template>
        <template v-else-if="users.length">
          <template v-if="isMyPosition">
            <BaseAvatar
              :size="55"
              :url="user.avatar.image_url"
            />
            <div class="pl-2">
              <span :class="$style.nameText">{{ $t('you') }}</span>
              <div :class="$style.scoreText">
                <span>{{ $t('score') }}:</span>&nbsp;{{ score }}
              </div>
            </div>
          </template>
          <template v-else>
            <BaseAvatar
              :size="55"
              :url="users[0].avatar"
            />
            <div class="pl-2">
              <span :class="$style.nameText">{{ users[0].name }}</span>
              <div :class="$style.scoreText">
                <span>{{ $t('score') }}:</span>&nbsp;{{ score }}
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <BaseAvatar :size="55" />
          <div class="pl-2">
            <span :class="$style.nameText">-----</span>
            <div :class="$style.scoreText">
              <span>{{ $t('score') }}:</span>&nbsp;{{ score }}
            </div>
          </div>
        </template>
      </div>
      <div class="d-flex align-items-center">
        <BaseButton
          v-if="users.length > 1"
          class="my-1"
          variant="outline-orange"
          font-size="small"
          is-rounded
          @click="handleSeeMorePlayers"
        >
          {{ $tc('and-x-more-player', usersCount - 1, { players: usersCount - 1}) }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseAvatar from '@/components/Atoms/BaseAvatar'
import BaseLoading from '@/components/Atoms/BaseLoading'
import BaseButton from '@/components/Atoms/BaseButton'

export default {
  name: 'ThePlayersStandingRow',
  components: { BaseButton, BaseLoading, BaseAvatar },
  props: {
    score: {
      type: [String, Number],
      default: 0,
    },
    users: {
      type: Array,
      required: true,
    },
    isUsersLoading: {
      type: Boolean,
      default: false,
    },
    rank: {
      type: Number,
      required: true,
    },
    isMyPosition: {
      type: Boolean,
      required: true,
    },
    usersCount: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  methods: {
    handleSeeMorePlayers() {
      this.$emit('onSetCurrentScore', { score: this.score })
      this.$emit('onSetCurrentRank', { rank: this.rank })
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";
  .wrapper {
    background: $color-white;
    display: flex;
    flex-direction: column;
    transition: all .3s ease-in-out;
    border-bottom: 2px solid lighten($color-windswept-beach, 5);
    &:hover {
      background: $color-bleached-silk;
    }

    .scoreText {
      font-size: $font-size-tiny;
    }
    .rankText {
      text-align: center;
      font-size: $font-size-xlarge;
      padding-right: .5rem;
      min-width: 30px;
    }
    .nameText {
      color: $color-midnight-blue;
      font-size: $font-size-small;
    }
  }

  .isMyPosition {
    background: lighten($color-alley, 15);
    &:hover {
      background: lighten($color-alley, 9);
    }
  }

</style>
